import React from "react";
import {
  Box,
  Image,
  Stack,
  Text,
  Link,
  Flex,
  SimpleGrid,
} from "@chakra-ui/react";
import { Icon } from "@chakra-ui/react";
import BWLOGO from "../media/logos/pn_logomark_bw.svg";

interface IAppFooter {}

const AppFooter: React.FC<IAppFooter> = () => {
  return (
    <Stack
      mt="100px"
      mb="20px"
      pl="20px"
      pr="8px"
      maxW={"6xl"}
      direction="column"
      gap={4}
      justify="space-between"
      align="left"
    >
      <SimpleGrid columns={2} fontSize="14px">
        <Box>
          <Link
            href={"https://palmfdn.org/#/privacy#privacy"}
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </Link>
        </Box>
        <Box>
          <Link
            href={"https://palmfdn.org/#/terms#terms"}
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Use
          </Link>
        </Box>
        <Box>
          <Link
            href={"https://docs.palm.network/"}
            target="_blank"
            rel="noopener noreferrer"
          >
            Palm Docs
          </Link>
        </Box>
        <Box>
          <Link
            href={"https://palm.chainlens.com/"}
            target="_blank"
            rel="noopener noreferrer"
          >
            Block Explorer
          </Link>
        </Box>
        <Box>
          <Link
            href={"https://palm.network"}
            target="_blank"
            rel="noopener noreferrer"
          >
            Palm Network
          </Link>
        </Box>
        <Box pt={"4px"}>
          <Link
            href={"https://discord.gg/palmnftstudio"}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon boxSize={7} asChild>
              <svg viewBox="0 0 127.14 96.36" fill="currentColor">
                <path d="M107.7,8.07A105.15,105.15,0,0,0,81.47,0a72.06,72.06,0,0,0-3.36,6.83A97.68,97.68,0,0,0,49,6.83,72.37,72.37,0,0,0,45.64,0,105.89,105.89,0,0,0,19.39,8.09C2.79,32.65-1.71,56.6.54,80.21h0A105.73,105.73,0,0,0,32.71,96.36,77.7,77.7,0,0,0,39.6,85.25a68.42,68.42,0,0,1-10.85-5.18c.91-.66,1.8-1.34,2.66-2a75.57,75.57,0,0,0,64.32,0c.87.71,1.76,1.39,2.66,2a68.68,68.68,0,0,1-10.87,5.19,77,77,0,0,0,6.89,11.1A105.25,105.25,0,0,0,126.6,80.22h0C129.24,52.84,122.09,29.11,107.7,8.07ZM42.45,65.69C36.18,65.69,31,60,31,53s5-12.74,11.43-12.74S54,46,53.89,53,48.84,65.69,42.45,65.69Zm42.24,0C78.41,65.69,73.25,60,73.25,53s5-12.74,11.44-12.74S96.23,46,96.12,53,91.08,65.69,84.69,65.69Z" />
              </svg>
            </Icon>
          </Link>
          <Link
            href={"https://t.me/PalmDAO_Community"}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon boxSize={10} asChild>
              <svg viewBox="0 0 1000 1000" fill="currentColor">
                <path d="M226.328419,494.722069 C372.088573,431.216685 469.284839,389.350049 517.917216,369.122161 C656.772535,311.36743 685.625481,301.334815 704.431427,301.003532 C708.567621,300.93067 717.815839,301.955743 723.806446,306.816707 C728.864797,310.92121 730.256552,316.46581 730.922551,320.357329 C731.588551,324.248848 732.417879,333.113828 731.758626,340.040666 C724.234007,419.102486 691.675104,610.964674 675.110982,699.515267 C668.10208,736.984342 654.301336,749.547532 640.940618,750.777006 C611.904684,753.448938 589.856115,731.588035 561.733393,713.153237 C517.726886,684.306416 492.866009,666.349181 450.150074,638.200013 C400.78442,605.66878 432.786119,587.789048 460.919462,558.568563 C468.282091,550.921423 596.21508,434.556479 598.691227,424.000355 C599.00091,422.680135 599.288312,417.758981 596.36474,415.160431 C593.441168,412.561881 589.126229,413.450484 586.012448,414.157198 C581.598758,415.158943 511.297793,461.625274 375.109553,553.556189 C355.154858,567.258623 337.080515,573.934908 320.886524,573.585046 C303.033948,573.199351 268.692754,563.490928 243.163606,555.192408 C211.851067,545.013936 186.964484,539.632504 189.131547,522.346309 C190.260287,513.342589 202.659244,504.134509 226.328419,494.722069 Z" />
              </svg>
            </Icon>
          </Link>
          <Link
            href={"https://twitter.com/buildonpalm"}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon boxSize={5} asChild>
              <svg viewBox="0 0 300 271" fill="currentColor">
                <path d="m236 0h46l-101 115 118 156h-92.6l-72.5-94.8-83 94.8h-46l107-123-113-148h94.9l65.5 86.6zm-16.1 244h25.5l-165-218h-27.4z" />
              </svg>
            </Icon>
          </Link>
        </Box>
      </SimpleGrid>
      <Flex alignItems="left" verticalAlign={"middle"}>
        <Box mr="24px">
          <Image src={BWLOGO} width="48px" alt="Palm" />
        </Box>
        <Text fontSize="14px">
          Copyright © {new Date().getFullYear()} Palm Foundation
        </Text>
      </Flex>
    </Stack>
  );
};

export default AppFooter;
